import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemText,
  Divider,
  Chip,
  Alert,
  Grid,
  Card,
  CardContent,
  Button,
  Link
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  Gavel as GavelIcon,
  Security as SecurityIcon,
  Payment as PaymentIcon,
  Group as GroupIcon,
  Cancel as CancelIcon,
  Help as HelpIcon,
  ContactSupport as ContactSupportIcon
} from '@mui/icons-material';

function TermsofService() {
  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // Smooth scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const sections = [
    {
      id: 'intro',
      title: 'Introduction and Acceptance',
      icon: <GavelIcon />,
      color: '#1976d2'
    },
    {
      id: 'service',
      title: 'Description of Service',
      icon: <SecurityIcon />,
      color: '#388e3c'
    },
    {
      id: 'accounts',
      title: 'User Accounts and Eligibility',
      icon: <GroupIcon />,
      color: '#f57c00'
    },
    {
      id: 'billing',
      title: 'Subscription Plans and Billing',
      icon: <PaymentIcon />,
      color: '#7b1fa2'
    },
    {
      id: 'circles',
      title: 'Circle Creation and Management',
      icon: <GroupIcon />,
      color: '#d32f2f'
    },
    {
      id: 'joining',
      title: 'Joining Circles',
      icon: <GroupIcon />,
      color: '#0288d1'
    },
    {
      id: 'cancellation',
      title: 'Cancellation and Termination',
      icon: <CancelIcon />,
      color: '#e64a19'
    },
    {
      id: 'refunds',
      title: 'Refunds and Satisfaction Guarantee',
      icon: <PaymentIcon />,
      color: '#00796b'
    }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 4, pt: 12 }}>  {/* Added more top padding for header */}
      {/* Header */}
      <Box sx={{ mb: 8, textAlign: 'center' }}>  {/* Increased bottom margin */}
        <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: '#1976d2' }}>
          Circledin Terms of Service
        </Typography>
        <Typography variant="h6" color="text.secondary" gutterBottom>
          Effective Date: January 1, 2025 | Last Updated: January 1, 2025 | Version: 2.0
        </Typography>
        <Chip label="Current Version" color="primary" sx={{ mt: 2 }} />
      </Box>

      {/* Quick Overview */}
      <Paper 
        elevation={6} 
        sx={{ 
          p: 5, 
          mb: 6, 
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
          color: 'white',
          borderRadius: '16px',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(45deg, rgba(255,255,255,0.1) 0%, transparent 50%)',
            pointerEvents: 'none'
          }
        }}
      >
        <Typography variant="h3" gutterBottom sx={{ fontWeight: 'bold', mb: 2 }}>
          Welcome to Circledin!
        </Typography>
        <Typography variant="h6" gutterBottom sx={{ mb: 4, opacity: 0.9 }}>
          Our Mission & Commitments:
        </Typography>
        <Grid container spacing={3} sx={{ mt: 2 }}>
          <Grid item xs={12} md={4}>
            <Card 
              sx={{ 
                bgcolor: 'rgba(255,255,255,0.15)', 
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
                }
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
                  1% Revenue
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', lineHeight: 1.6 }}>
                  Donated to charitable foundations
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card 
              sx={{ 
                bgcolor: 'rgba(255,255,255,0.15)', 
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
                }
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
                  1% Time
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', lineHeight: 1.6 }}>
                  Volunteered for charitable causes
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card 
              sx={{ 
                bgcolor: 'rgba(255,255,255,0.15)', 
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.2)',
                borderRadius: '12px',
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
                }
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Typography variant="h5" sx={{ color: 'white', fontWeight: 'bold', mb: 2 }}>
                  100% Guarantee
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.9)', lineHeight: 1.6 }}>
                  Satisfaction guarantee on our services
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Paper>

      {/* Important Notice */}
      <Alert 
        severity="info" 
        sx={{ 
          mb: 5, 
          p: 3,
          borderRadius: '12px',
          border: '1px solid #2196f3',
          boxShadow: '0 4px 16px rgba(33, 150, 243, 0.1)'
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 1 }}>
          Important: Circledin is NOT a mobile carrier, reseller, or MVNO.
        </Typography>
        <Typography variant="body1">
          We act solely as an intermediary platform connecting users with existing carrier plans.
        </Typography>
      </Alert>

      {/* Table of Contents */}
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          mb: 5,
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)'
        }}
      >
        <Typography 
          variant="h4" 
          gutterBottom 
          sx={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2,
            fontWeight: 'bold',
            color: '#1976d2',
            mb: 3
          }}
        >
          <HelpIcon sx={{ fontSize: '2rem' }} /> Table of Contents
        </Typography>
        <Grid container spacing={3}>
          {sections.map((section, index) => (
            <Grid item xs={12} sm={6} md={3} key={section.id}>
              <Button
                fullWidth
                variant="outlined"
                startIcon={section.icon}
                onClick={() => document.getElementById(section.id)?.scrollIntoView({ behavior: 'smooth' })}
                sx={{ 
                  justifyContent: 'flex-start', 
                  color: section.color, 
                  borderColor: section.color,
                  borderRadius: '12px',
                  p: 2,
                  height: 'auto',
                  textAlign: 'left',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: `${section.color}10`,
                    transform: 'translateY(-2px)',
                    boxShadow: `0 4px 16px ${section.color}30`
                  }
                }}
              >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', width: '100%' }}>
                  <Typography variant="body2" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                    {index + 1}. {section.title}
                  </Typography>
                </Box>
              </Button>
            </Grid>
          ))}
        </Grid>
      </Paper>

      {/* Terms Content */}
      <Box sx={{ mb: 6 }}>
        
        {/* Section 1: Introduction */}
        <Accordion 
          expanded={expanded === 'panel1'} 
          onChange={handleChange('panel1')} 
          id="intro"
          elevation={2}
          sx={{
            mb: 2,
            borderRadius: '12px !important',
            '&:before': { display: 'none' },
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            '&.Mui-expanded': {
              margin: '0 0 16px 0'
            }
          }}
        >
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: '#f8f9fc',
              borderRadius: '12px',
              '&.Mui-expanded': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
            }}
          >
            <GavelIcon sx={{ mr: 2, color: '#1976d2' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>1. Introduction and Acceptance of Terms</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 4, backgroundColor: '#ffffff' }}>
            <Typography paragraph>
              Welcome to Circledin! These Terms of Service ("Terms") constitute a legally binding agreement between you ("User," "you," or "your") and Circledin, LLC. ("Circledin," "we," "us," or "our") governing your use of our website, mobile application, and related services (collectively, the "Service").
            </Typography>
            <Typography paragraph>
              By accessing or using our Service, you agree to be bound by these Terms and our Privacy Policy, which is incorporated herein by reference. If you do not agree to these Terms, you may not access or use our Service.
            </Typography>
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Our Mission and Commitments</Typography>
            <Typography paragraph>
              Circledin is committed to helping users save money on mobile phone plans through group discounts. As part of our commitment to the community:
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="We donate 1% of our revenue to charitable foundations" />
              </ListItem>
              <ListItem>
                <ListItemText primary="We pledge 1% of our time to volunteer for charitable causes" />
              </ListItem>
              <ListItem>
                <ListItemText primary="We provide a 100% satisfaction guarantee on our services" />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Section 2: Description of Service */}
        <Accordion 
          expanded={expanded === 'panel2'} 
          onChange={handleChange('panel2')} 
          id="service"
          elevation={2}
          sx={{
            mb: 2,
            borderRadius: '12px !important',
            '&:before': { display: 'none' },
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            '&.Mui-expanded': {
              margin: '0 0 16px 0'
            }
          }}
        >
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: '#f8f9fc',
              borderRadius: '12px',
              '&.Mui-expanded': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
            }}
          >
            <SecurityIcon sx={{ mr: 2, color: '#388e3c' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>2. Description of Service</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 4, backgroundColor: '#ffffff' }}>
            <Typography variant="h6" gutterBottom>What Circledin Does</Typography>
            <Typography paragraph>
              Circledin is a platform that facilitates group discounts on mobile phone plans by connecting users who want to share family plans offered by major carriers including Verizon, AT&T, T-Mobile, Cricket, Google Fi, and others.
            </Typography>
            
            <Alert severity="warning" sx={{ my: 2 }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                Important: Circledin is NOT a mobile carrier, reseller, or Mobile Virtual Network Operator (MVNO).
              </Typography>
              <Typography variant="body2">
                We do not provide mobile services directly. We act solely as an intermediary platform connecting users with existing carrier plans.
              </Typography>
            </Alert>
            
            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Types of Users</Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Circle Creators/Owners" 
                  secondary="Users who own or manage existing carrier accounts and create circles to share their plans"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Circle Joiners" 
                  secondary="Users who join existing circles created by Circle Owners"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Individual Users" 
                  secondary="Users who browse available plans and services"
                />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Service Features</Typography>
            <Typography paragraph>Our Service includes:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Access to available carrier plans and group discounts" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Matching system to connect Joiners with Circle Owners" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Payment processing for Circledin subscription fees" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Customer support and dispute resolution" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Account management tools and dashboards" />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Section 3: User Accounts */}
        <Accordion 
          expanded={expanded === 'panel3'} 
          onChange={handleChange('panel3')} 
          id="accounts"
          elevation={2}
          sx={{
            mb: 2,
            borderRadius: '12px !important',
            '&:before': { display: 'none' },
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            '&.Mui-expanded': {
              margin: '0 0 16px 0'
            }
          }}
        >
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: '#f8f9fc',
              borderRadius: '12px',
              '&.Mui-expanded': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
            }}
          >
            <GroupIcon sx={{ mr: 2, color: '#f57c00' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>3. User Accounts and Eligibility</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 4, backgroundColor: '#ffffff' }}>
            <Typography variant="h6" gutterBottom>Account Creation</Typography>
            <Typography paragraph>
              To access certain features of our Service, you must create an account. You agree to:
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Provide accurate, current, and complete information" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Maintain the security of your account credentials" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Notify us immediately of any unauthorized access" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Be responsible for all activities under your account" />
              </ListItem>
            </List>
            
            <Alert severity="warning" sx={{ mt: 3, borderRadius: '8px' }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                Eligibility Requirements:
              </Typography>
              <Typography variant="body2">
                You must be at least 18 years old and legally capable of entering into binding contracts to use our Service. By using our Service, you represent and warrant that you meet these requirements.
              </Typography>
            </Alert>

            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>Account Verification</Typography>
            <Typography paragraph>
              Circle Owners may be required to undergo additional verification processes, including but not limited to:
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Identity verification" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Carrier account ownership verification" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Credit and background checks (at our discretion)" />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Section 4: Billing */}
        <Accordion 
          expanded={expanded === 'panel4'} 
          onChange={handleChange('panel4')} 
          id="billing"
          elevation={2}
          sx={{
            mb: 2,
            borderRadius: '12px !important',
            '&:before': { display: 'none' },
            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
            '&.Mui-expanded': {
              margin: '0 0 16px 0'
            }
          }}
        >
          <AccordionSummary 
            expandIcon={<ExpandMoreIcon />}
            sx={{
              backgroundColor: '#f8f9fc',
              borderRadius: '12px',
              '&.Mui-expanded': {
                borderBottomLeftRadius: 0,
                borderBottomRightRadius: 0,
              }
            }}
          >
            <PaymentIcon sx={{ mr: 2, color: '#7b1fa2' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>4. Subscription Plans and Billing</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 4, backgroundColor: '#ffffff' }}>
            <Typography variant="h6" gutterBottom>Circledin Subscription Fees</Typography>
            <Typography paragraph>Our Service operates on a subscription basis. Current subscription options include:</Typography>
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} md={4}>
                <Card 
                  variant="outlined"
                  sx={{
                    borderRadius: '16px',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                    }
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>Monthly Plan</Typography>
                    <Typography variant="h3" sx={{ fontWeight: 'bold', my: 2, color: '#1976d2' }}>$12</Typography>
                    <Typography variant="body2" color="text.secondary">per month</Typography>
                    <Typography variant="caption" display="block" sx={{ mt: 1 }}>Billed monthly</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card 
                  variant="outlined"
                  sx={{
                    borderRadius: '16px',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 24px rgba(0,0,0,0.12)'
                    }
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold' }}>3-Month Plan</Typography>
                    <Typography variant="h3" sx={{ fontWeight: 'bold', my: 2, color: '#1976d2' }}>$12</Typography>
                    <Typography variant="body2" color="text.secondary">per month</Typography>
                    <Typography variant="caption" display="block" sx={{ mt: 1 }}>Billed quarterly</Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card 
                  variant="outlined" 
                  sx={{ 
                    border: '3px solid #4caf50',
                    borderRadius: '16px',
                    position: 'relative',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 8px 24px rgba(76, 175, 80, 0.2)'
                    }
                  }}
                >
                  <CardContent sx={{ textAlign: 'center', p: 3 }}>
                    <Chip 
                      label="Best Value" 
                      color="success" 
                      size="small" 
                      sx={{ 
                        mb: 2,
                        fontWeight: 'bold',
                        position: 'absolute',
                        top: -10,
                        left: '50%',
                        transform: 'translateX(-50%)'
                      }} 
                    />
                    <Typography variant="h6" color="primary" sx={{ fontWeight: 'bold', mt: 2 }}>Annual Plan</Typography>
                    <Typography variant="h3" sx={{ fontWeight: 'bold', my: 2, color: '#4caf50' }}>$8</Typography>
                    <Typography variant="body2" color="text.secondary">per month</Typography>
                    <Typography variant="caption" display="block" sx={{ mt: 1 }}>Billed annually</Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>

            <Typography variant="h6" gutterBottom>Billing and Payment</Typography>
            <List>
              <ListItem>
                <ListItemText primary="All subscription fees are billed in advance" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Payment is processed through our secure payment processor (Stripe)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="You authorize us to charge your selected payment method" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Subscription fees are separate from and in addition to carrier charges" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Automatic Renewal</Typography>
            <Typography paragraph>
              Subscriptions automatically renew unless cancelled before the renewal date. You may cancel your subscription at any time through your account settings or by contacting customer support.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Additional Fees</Typography>
            <Typography paragraph>You may incur additional charges including:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Carrier activation fees (typically $35 per line)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Shipping costs for physical SIM cards" />
              </ListItem>
              <ListItem>
                <ListItemText primary="International roaming charges" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Data overage fees (charged by your carrier)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Late payment fees (charged by your carrier)" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Proration and Partial Month Billing</Typography>
            <Alert severity="info" sx={{ mb: 2 }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                Customer Responsibility for Prorated Costs:
              </Typography>
              <Typography variant="body2">
                You are responsible for all prorated charges when joining AND when leaving a circle mid-billing cycle. No prorated refunds will be provided for Circledin subscription fees if you leave before the cycle ends.
              </Typography>
            </Alert>

            <Typography paragraph>
              <strong>Billing Method:</strong> We bill strictly based on what the carrier generates on their bill. All carrier charges, taxes, and fees are passed through to you without markup.
            </Typography>

            <Alert severity="error" sx={{ mt: 3 }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                IMPORTANT WARNING ABOUT PAYMENT FAILURES:
              </Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Payment failures can result in permanent loss of your phone number" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="After 1 week of non-payment, your line will be suspended" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Once cancelled by carrier, phone numbers cannot be recovered" />
                </ListItem>
              </List>
            </Alert>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Understanding Your Billing Structure</Typography>
            <Typography paragraph><strong>Your total monthly cost consists of two separate charges:</strong></Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Circledin Subscription Fee" 
                  secondary="Billed directly by Circledin for platform access and support"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Carrier Plan Cost" 
                  secondary="You pay the dynamic pricing rate based on current number of members in the circle at checkout"
                />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Your First Carrier Bill Will Include:</Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Carrier Activation Fee" 
                  secondary="One-time fee ranging from $30-$35 (waived if carrier doesn't charge)"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Prorated Charges" 
                  secondary="Partial month charges from your activation date to the end of the billing cycle"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Next Month Charges" 
                  secondary="Full month charges for the upcoming billing period"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="Taxes and Surcharges" 
                  secondary="Variable fees that fluctuate monthly (inflated on first bill, typically $2-$3 monthly thereafter)"
                />
              </ListItem>
            </List>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              <strong>Note:</strong> T-Mobile includes taxes and fees in their advertised price
            </Typography>
          </AccordionDetails>
        </Accordion>

        {/* Section 5: Circle Creation */}
        <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')} id="circles">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <GroupIcon sx={{ mr: 2, color: '#d32f2f' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>5. Circle Creation and Management</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6" gutterBottom>Circle Owner Responsibilities</Typography>
            <Typography paragraph>As a Circle Owner, you agree to:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Maintain an active carrier account in good standing" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Provide accurate information about your plan and availability" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Respond promptly to join requests and communications" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Manage your circle in accordance with carrier terms" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Provide 30 days advance notice before discontinuing your circle" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Facilitate the release of Joiners' phone numbers when requested" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Circle Owner Verification</Typography>
            <Typography paragraph>Circle Owners must undergo verification including:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Proof of carrier account ownership" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Identity verification" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Payment method verification" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Background checks (if required)" />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Section 6: Joining Circles */}
        <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')} id="joining">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <GroupIcon sx={{ mr: 2, color: '#0288d1' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>6. Joining Circles</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6" gutterBottom>Joiner Responsibilities</Typography>
            <Typography paragraph>As a Circle Joiner, you agree to:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Provide accurate information for joining a circle" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Pay all applicable fees promptly" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Comply with the carrier's terms of service" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Respect the Circle Owner's reasonable rules and requests" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Provide notice before leaving a circle" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Number Portability</Typography>
            <Typography paragraph>When joining a circle:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="You may port your existing number to the new carrier" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Number portability is subject to carrier policies and technical limitations" />
              </ListItem>
              <ListItem>
                <ListItemText primary="We cannot guarantee successful number ports" />
              </ListItem>
              <ListItem>
                <ListItemText primary="You are responsible for any fees associated with number porting" />
              </ListItem>
            </List>

            <Alert severity="warning" sx={{ mt: 2 }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                Number Portability Notice:
              </Typography>
              <Typography variant="body2">
                While you may port your existing number, we cannot guarantee successful number ports. Number portability is subject to carrier policies and technical limitations.
              </Typography>
            </Alert>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Joining Process</Typography>
            <Typography paragraph>The joining process typically includes:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Selecting an available circle" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Providing required information and documentation" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Paying applicable fees" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Waiting for Circle Owner approval" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Completing carrier activation process" />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Section 7: Cancellation */}
        <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')} id="cancellation">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <CancelIcon sx={{ mr: 2, color: '#e64a19' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>7. Cancellation and Termination</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6" gutterBottom>Cancellation by Users</Typography>
            
            <Typography variant="subtitle1" gutterBottom sx={{ mt: 2, fontWeight: 'bold' }}>For Joiners:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="You may leave a circle at any time" />
              </ListItem>
              <ListItem>
                <ListItemText primary="You are subject to the carrier's terms regarding line cancellation" />
              </ListItem>
              <ListItem>
                <ListItemText primary="You must pay all outstanding fees before leaving" />
              </ListItem>
              <ListItem>
                <ListItemText primary="We will work with the Circle Owner to facilitate number release, but cannot guarantee success" />
              </ListItem>
            </List>

            <Typography variant="subtitle1" gutterBottom sx={{ mt: 3, fontWeight: 'bold' }}>For Circle Owners:</Typography>
            <Alert severity="error" sx={{ mb: 2 }}>
              <Typography variant="body2">
                <strong>Required:</strong> You must provide 30 days advance notice before closing your circle
              </Typography>
            </Alert>
            <List>
              <ListItem>
                <ListItemText primary="You must facilitate the release of all Joiners' phone numbers" />
              </ListItem>
              <ListItem>
                <ListItemText primary="You are responsible for all fees incurred during the notice period" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Failure to provide proper notice may result in account suspension" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Termination by Circledin</Typography>
            <Typography paragraph>We may suspend or terminate your account if you:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Violate these Terms or our policies" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Fail to pay required fees" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Engage in fraudulent or illegal activities" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Fail to cooperate with number release processes" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Repeatedly violate carrier terms of service" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Effect of Termination</Typography>
            <Typography paragraph>Upon termination:</Typography>
            <List>
              <ListItem>
                <ListItemText primary="Your access to the Service will be discontinued" />
              </ListItem>
              <ListItem>
                <ListItemText primary="You remain responsible for all outstanding fees" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Certain provisions of these Terms will survive termination" />
              </ListItem>
            </List>
          </AccordionDetails>
        </Accordion>

        {/* Section 8: Refunds */}
        <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')} id="refunds">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <PaymentIcon sx={{ mr: 2, color: '#00796b' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>8. Refunds and Satisfaction Guarantee</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Alert severity="success" sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                100% Satisfaction Guarantee
              </Typography>
              <Typography variant="body2">
                If you are not completely satisfied with our Service within the first month of subscription, we will provide a full refund of Circledin subscription fees paid.
              </Typography>
            </Alert>

            <Typography variant="h6" gutterBottom>Refund Policy</Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="Refunds are limited to Circledin subscription fees only"
                  secondary="Carrier fees, activation fees, and shipping costs are non-refundable"
                />
              </ListItem>
              <ListItem>
                <ListItemText primary="Refund requests must be made within 30 days of initial subscription" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Refunds are processed within 5-10 business days" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Refund Processing Timeframes</Typography>
            <Typography paragraph><strong>Processing Timeline:</strong></Typography>
            <List>
              <ListItem>
                <ListItemText primary="Refund requests are reviewed within 2 business days of submission" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Approved refunds are processed through Stripe within 5-10 business days" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Bank processing may take an additional 3-5 business days depending on your financial institution" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Total refund timeline: 7-15 business days from approval to account credit" />
              </ListItem>
            </List>

            <Typography paragraph><strong>Refund Methods:</strong></Typography>
            <List>
              <ListItem>
                <ListItemText primary="Refunds are issued to the original payment method used for the subscription" />
              </ListItem>
              <ListItem>
                <ListItemText primary="If the original payment method is no longer valid, alternative arrangements will be made" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Refunds cannot be issued as cash or to different payment methods without verification" />
              </ListItem>
            </List>

            <Alert severity="warning" sx={{ mt: 3 }}>
              <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                No Refund Situations:
              </Typography>
              <Typography variant="body2">Refunds will not be provided for:</Typography>
              <List dense>
                <ListItem>
                  <ListItemText primary="Violations of these Terms" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Fraudulent or illegal activities" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Failure to pay carrier fees" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Disputes between users that result in service disruption" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Early departures from circles before the billing cycle ends (no prorated refunds)" />
                </ListItem>
                <ListItem>
                  <ListItemText primary="Carrier charges, activation fees, shipping costs, or any third-party fees" />
                </ListItem>
              </List>
            </Alert>
          </AccordionDetails>
        </Accordion>

        {/* Additional Important Sections */}
        <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')} id="limitations">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <SecurityIcon sx={{ mr: 2, color: '#f44336' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>9. Limitations of Liability and Disclaimers</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Alert severity="warning" sx={{ mb: 3 }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                Service Disclaimers
              </Typography>
              <Typography variant="body2">
                THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND. WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT.
              </Typography>
            </Alert>

            <Typography variant="h6" gutterBottom>Limitation of Liability</Typography>
            <Typography paragraph>
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, CIRCLEDIN SHALL NOT BE LIABLE FOR:
            </Typography>
            <List>
              <ListItem>
                <ListItemText primary="Loss of mobile phone numbers" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Service interruptions by carriers" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Disputes between Circle Owners and Joiners" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Carrier fees or charges" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Indirect, incidental, or consequential damages" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Damages exceeding the amount paid to Circledin in the preceding 12 months" />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Carrier Relationship Disclaimer</Typography>
            <Typography paragraph>
              We are not affiliated with, endorsed by, or acting as agents for any mobile carriers. All carrier services are subject to the carrier's own terms and conditions.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion expanded={expanded === 'panel10'} onChange={handleChange('panel10')} id="disputes">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <GavelIcon sx={{ mr: 2, color: '#9c27b0' }} />
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>10. Dispute Resolution</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="h6" gutterBottom>Customer Success Commitment</Typography>
            <Typography paragraph>
              Customer success and trust are core values. We will work diligently to resolve any disputes or issues you may have with our Service.
            </Typography>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Dispute Resolution Process</Typography>
            <List>
              <ListItem>
                <ListItemText 
                  primary="1. Direct Resolution" 
                  secondary="Contact our customer support team first"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="2. Mediation" 
                  secondary="If direct resolution fails, we may engage in mediation"
                />
              </ListItem>
              <ListItem>
                <ListItemText 
                  primary="3. Arbitration" 
                  secondary="Binding arbitration as the final resolution method"
                />
              </ListItem>
            </List>

            <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>Arbitration Agreement</Typography>
            <Typography paragraph>
              Any disputes arising from these Terms or your use of the Service shall be resolved through binding arbitration in accordance with the rules of the American Arbitration Association.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>

      {/* Footer */}
      <Box sx={{ mt: 6, textAlign: 'center', borderTop: '1px solid #e0e0e0', pt: 4 }}>  {/* Enhanced spacing */}
        <Typography variant="body2" color="text.secondary">
          Last Updated: January 1, 2025 | Version: 2.0
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          © 2025 Circledin, LLC. All rights reserved.
        </Typography>
      </Box>
    </Container>
  );
}

export default TermsofService;